export const PROPERTYMARK_ARTICLE_SLUG = "propertymark-one-2026";

const IMAGE_BASE = "/media/news/propertymark-one-2026";

export type ArticleImage = {
  src: string;
  alt: string;
  caption?: string;
};

export type ArticleBlock =
  | { type: "paragraph"; text: string }
  | ({ type: "image" } & ArticleImage);

export const propertymarkArticle = {
  slug: PROPERTYMARK_ARTICLE_SLUG,
  title: "Letting Engine at Propertymark One 2026",
  date: "2026-06-12",
  venue: "ExCeL London",
  excerpt:
    "Letting Engine joined estate agents, industry experts, and policymakers at Propertymark One 2026 to explore how the UK property sector is adapting to today's market.",
  speakers: [
    "Sir Mel Stride",
    "Angela Rayner",
    "Baroness Karren Brady",
    "Daisy McAndrew",
    "Lara Lewington",
  ],
  heroImage: {
    src: `${IMAGE_BASE}/registration-welcome.png`,
    alt: "Registration area at Propertymark One 2026, ExCeL London",
    caption: "Welcome to Propertymark One 2026 at ExCeL London.",
  } satisfies ArticleImage,
  content: [
    {
      type: "paragraph",
      text: "On 12 June 2026, Letting Engine was invited to Propertymark One 2026 at ExCeL London. The event brought together estate agents, industry experts, policymakers, and service providers from across the UK to exchange views on the challenges and opportunities facing the property sector in the current market environment.",
    },
    {
      type: "image",
      src: `${IMAGE_BASE}/registration-banner.png`,
      alt: "Propertymark One registration and exhibition signage",
      caption: "Registration and exhibition areas at Propertymark One.",
    },
    {
      type: "paragraph",
      text: "Propertymark One is one of the UK's most influential annual events for the property industry. This year's programme covered property tax reform, changes to tenancy law, compliance requirements, future regulation, operational efficiency, and business profitability — combining macro-level policy and market analysis with practical insights for day-to-day operations.",
    },
    {
      type: "image",
      src: `${IMAGE_BASE}/exhibition-hall.png`,
      alt: "Exhibition hall with Rightmove and industry stands",
      caption: "The main exhibition hall brought together leading property brands.",
    },
    {
      type: "paragraph",
      text: "At the event, Letting Engine focused on UK property market trends and sales and lettings topics, including valuation, compliance management, portfolio growth, and the practical application of artificial intelligence in client service. These themes are closely tied to how property service businesses operate day to day, and gave Letting Engine useful reference points for refining service delivery and improving the client experience.",
    },
    {
      type: "image",
      src: `${IMAGE_BASE}/propertymark-stand.png`,
      alt: "Propertymark membership stand at the event",
      caption: "Propertymark's stand highlighted membership and professional standards.",
    },
    {
      type: "paragraph",
      text: "The conference featured several high-profile speakers, including Sir Mel Stride, Angela Rayner, Baroness Karren Brady, Daisy McAndrew, and Lara Lewington. They shared perspectives on economic policy, housing reform, business management, media, and technology, offering attendees a broader view of the industry.",
    },
    {
      type: "image",
      src: `${IMAGE_BASE}/angela-rayner-keynote.png`,
      alt: "Angela Rayner speaking at Propertymark One 2026",
      caption: "Rt Hon Angela Rayner MP was among the headline speakers.",
    },
    {
      type: "paragraph",
      text: "For Letting Engine, being invited to Propertymark One 2026 was an important opportunity to learn and connect. As markets, regulation, and client expectations continue to evolve, the event helped Letting Engine better understand the direction of the UK property industry and build relationships with peers across the sector.",
    },
    {
      type: "image",
      src: `${IMAGE_BASE}/panel-discussion.png`,
      alt: "Panel discussion on offer to completion at Propertymark One",
      caption:
        "Panel session: From offer to completion — what's slowing us down and how to fix it.",
    },
    {
      type: "paragraph",
      text: "The day's agenda was packed and practical. From market briefings and panel discussions to hands-on sessions and networking, Propertymark One 2026 gave property professionals a high-quality platform to exchange ideas. Letting Engine used the occasion to absorb industry experience, broaden its professional outlook, and apply what it learned to future service and operations.",
    },
    {
      type: "image",
      src: `${IMAGE_BASE}/industry-stands.png`,
      alt: "PayProp and Reapit exhibition stands",
      caption: "Industry partners including PayProp and Reapit exhibited at the event.",
    },
    {
      type: "paragraph",
      text: "Letting Engine values industry engagement and professional development. Taking part in Propertymark One 2026 reflects our continued focus on the UK property market and our commitment to professionalism, compliance, and ongoing service improvement.",
    },
  ] satisfies ArticleBlock[],
};
